// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Arial, sans-serif;
  margin: 20px;
  padding: 0;
  background-color: #f9f9f9;
}

h1 {
  color: #ff5722;
}

button {
  margin: 5px;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  background-color: #ff5722;
  color: white;
  cursor: pointer;
}

button:hover {
  background-color: #e64a19;
}

hr {
  margin: 20px 0;
}
#userInfo {
  margin: 10px 0;
  font-weight: bold;
}
#taskOutput {
  background-color: #f0f0f0;
  padding: 10px;
  border-radius: 5px;
  white-space: pre-wrap;
  word-break: break-all;
  margin-top: 10px;
  max-height: 200px;
  overflow-y: auto;
}
#userImageInput {
  display: block;
  margin: 10px 0;
}
#uploadBtn {
  margin-top: 10px;
  margin-left: 10px;
  background-color: #4caf50;
}
#uploadBtn:hover {
  background-color: #45a049;
}
label {
  display: block;
  margin: 10px 0;
}
input[type="file"] {
  display: block;
  margin: 10px 0;
}
pre {
  background-color: #f0f0f0;
  padding: 10px;
  border-radius: 5px;
  white-space: pre-wrap;
  word-break: break-all;
}
h2 {
  color: #333;
}
#writeTaskBtn {
  background-color: #2196f3;
}
#writeTaskBtn:hover {
  background-color: #1976d2;
}
#signOutBtn {
  background-color: #f44336;
}
#signOutBtn:hover {
  background-color: #d32f2f;
}
#googleSignInBtn {
  background-color: #4285f4;
}
#googleSignInBtn:hover {
  background-color: #357ae8;
}
#taskOutput:empty::before {
  content: "No tasks written yet.";
  color: #999;
}
#deleteTaskBtn {
  background-color: #f44336;
}
#deleteTaskBtn:hover {
  background-color: #d32f2f;
}
#updateTaskBtn {
  background-color: #ff9800;
}
#updateTaskBtn:hover {
  background-color: #f57c00;
}
#displayAllTasks {
  background-color: #45a049;
}
#displayAllTasks:hover {
  background-color: #388e3c;
}
label[id="customUserImageLabel"] {
  cursor: pointer;
  display: inline-block;
  padding: 10px 15px;
  background-color: #ff9800;
  color: white;
  border-radius: 5px;
  margin-right: 10px;
  font-size: 14px;
  font-family: Arial, sans-serif;
  transition: background 0.2s;
}
span[id="userImageName"] {
  display: inline-block;
  margin-left: 10px;
  font-size: 14px;
  color: #555;
}
.logged-in-only {
  display: none;
}
#taskInput, #taskUpdateInput, #taskIdInputDelete, #taskIdInputUpdate, #emailInput, #passwordInput {
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":["body {\n  font-family: Arial, sans-serif;\n  margin: 20px;\n  padding: 0;\n  background-color: #f9f9f9;\n}\n\nh1 {\n  color: #ff5722;\n}\n\nbutton {\n  margin: 5px;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  background-color: #ff5722;\n  color: white;\n  cursor: pointer;\n}\n\nbutton:hover {\n  background-color: #e64a19;\n}\n\nhr {\n  margin: 20px 0;\n}\n#userInfo {\n  margin: 10px 0;\n  font-weight: bold;\n}\n#taskOutput {\n  background-color: #f0f0f0;\n  padding: 10px;\n  border-radius: 5px;\n  white-space: pre-wrap;\n  word-break: break-all;\n  margin-top: 10px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n#userImageInput {\n  display: block;\n  margin: 10px 0;\n}\n#uploadBtn {\n  margin-top: 10px;\n  margin-left: 10px;\n  background-color: #4caf50;\n}\n#uploadBtn:hover {\n  background-color: #45a049;\n}\nlabel {\n  display: block;\n  margin: 10px 0;\n}\ninput[type=\"file\"] {\n  display: block;\n  margin: 10px 0;\n}\npre {\n  background-color: #f0f0f0;\n  padding: 10px;\n  border-radius: 5px;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\nh2 {\n  color: #333;\n}\n#writeTaskBtn {\n  background-color: #2196f3;\n}\n#writeTaskBtn:hover {\n  background-color: #1976d2;\n}\n#signOutBtn {\n  background-color: #f44336;\n}\n#signOutBtn:hover {\n  background-color: #d32f2f;\n}\n#googleSignInBtn {\n  background-color: #4285f4;\n}\n#googleSignInBtn:hover {\n  background-color: #357ae8;\n}\n#taskOutput:empty::before {\n  content: \"No tasks written yet.\";\n  color: #999;\n}\n#deleteTaskBtn {\n  background-color: #f44336;\n}\n#deleteTaskBtn:hover {\n  background-color: #d32f2f;\n}\n#updateTaskBtn {\n  background-color: #ff9800;\n}\n#updateTaskBtn:hover {\n  background-color: #f57c00;\n}\n#displayAllTasks {\n  background-color: #45a049;\n}\n#displayAllTasks:hover {\n  background-color: #388e3c;\n}\nlabel[id=\"customUserImageLabel\"] {\n  cursor: pointer;\n  display: inline-block;\n  padding: 10px 15px;\n  background-color: #ff9800;\n  color: white;\n  border-radius: 5px;\n  margin-right: 10px;\n  font-size: 14px;\n  font-family: Arial, sans-serif;\n  transition: background 0.2s;\n}\nspan[id=\"userImageName\"] {\n  display: inline-block;\n  margin-left: 10px;\n  font-size: 14px;\n  color: #555;\n}\n.logged-in-only {\n  display: none;\n}\n#taskInput, #taskUpdateInput, #taskIdInputDelete, #taskIdInputUpdate, #emailInput, #passwordInput {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 10px;\n  margin-top: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
